import * as React from "react";

function SvgSeparatorIcon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}><path d="M18.2 0H1.8C.8 0 0 .8 0 1.8v16.3c0 1 .8 1.8 1.8 1.8h16.3c1 0 1.8-.8 1.8-1.8V1.8c.1-1-.7-1.8-1.7-1.8zM1.5 1.8c0-.2.1-.3.3-.3h16.3c.2 0 .3.1.3.3v7.1c-.8.7-2.2 2.1-4.1 2.1-3.1 0-4.8-3.6-8.1-3.6-1.9 0-3.7 1.3-4.6 2.1V1.8zm17 16.3c0 .3-.2.4-.3.4H1.8c-.2 0-.3-.1-.3-.3V12c.9-.9 2.7-2.7 4.5-2.7 2.7 0 4.3 3.4 8.3 3.4 1.9 0 3.4-1 4.1-1.6v7z" /></svg>;
}

export default SvgSeparatorIcon;